<template>
  <div>
    <va-modal
      ref="addCriteriaModal"
      :value="isOpen"
      :noOutsideDismiss="true"
      :okText="$t('modals.buttons.save')"
      :cancelText="$t('modals.buttons.cancel')"
      size="large"
      @ok="submitForm"
      @cancel="onCancel"
      :okDisabled="!submitEnabled"
    >
      <div slot="header" class="modal-title">
        <span>{{ $t('entities.entity_aud_provider_forwarding_rules.add_criteria') }}</span>
      </div>


      <div class="mt-4 ml-2 mr-2">
        <div class="row">
          <div class="col-4">
            <label class="form-label">{{ $t('entities.entity_aud_provider_forwarding_rules.criterias.lead_field') }}</label>
            <multiselect
              :options="leadFields"
              id="client"
              v-model="form.lead_field"
              label="name"
              track-by="id"
              :placeholder="$t('entities.entity_aud_provider_forwarding_rules.criterias.lead_field')"
              open-direction="bottom"
              :allow-empty="false"
              :multiple="false"
              :searchable="true"
            >
              <span slot="noResult">{{ $t('patients.noResults') }}</span>
            </multiselect>

          </div>

          <div class="col-3">
            <label class="form-label">{{ $t('entities.entity_aud_provider_forwarding_rules.criterias.comparator') }}</label>
            <multiselect
              :options="filteredComparators"
              id="client"
              v-model="form.comparator"
              label="comparator"
              track-by="id"
              :placeholder="$t('entities.entity_aud_provider_forwarding_rules.criterias.comparator')"
              open-direction="bottom"
              :allow-empty="false"
              :multiple="false"
              :searchable="true"
              :disabled="!form.lead_field"
            >
              <span slot="noResult">{{ $t('patients.noResults') }}</span>
            </multiselect>

          </div>

          <div class="col-3">
            <label class="form-label">{{ $t('entities.entity_aud_provider_forwarding_rules.criterias.value') }}</label>
            <va-input
              :disabled="form.lead_field ? form.lead_field.valueDisabled : true"
              id="name"
              v-model="form.value"
              :placeholder="$t('entities.entity_aud_provider_forwarding_rules.criterias.value')"
              :maxlength=16
            />
          </div>

        </div>

      </div>



    </va-modal>
  </div>

</template>

<script>
import Multiselect from 'vue-multiselect';
import { LeadsService } from '@/api/LeadsService';

export default {
  components: { Multiselect },
  props: {
    rule: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      isOpen: false,
      leadFields: [
        {id: 1, name: 'questionnaire', allowedComparators: [ {id: 1, comparator: 'notEmpty'}], valueDisabled: true},
        {id: 2, name: 'phone', allowedComparators: [ {id: 1, comparator: 'notNull'}], valueDisabled: true},
        {id: 3, name: 'email', allowedComparators: [{id: 1, comparator: 'notNull'}], valueDisabled: true},
        {id: 4, name: 'hearingTest', allowedComparators: [{id: 1, comparator: 'notNull'}], valueDisabled: true},
        {id: 5, name: 'hearing_loss', allowedComparators: [
          {id: 1, comparator: '>='},
            {id: 2, comparator: '<='},
            {id: 3, comparator: '>'},
            {id: 4, comparator: '<'},
            {id: 5, comparator: '==='},
            {id: 6, comparator: '!=='}],
          valueDisabled: false},
      ],
      form: {
        lead_field: null,
        comparator: null,
        value: null
      }
    }

  },
  mounted: function () {
    this.isOpen = true
  },
  methods:  {


    async submitForm() {
      let data = {}
      data.lead_field = this.form.lead_field.name
      data.comparator = this.form.comparator.comparator
      data.value = this.form.value

      try {
        let responseData = await LeadsService.addCriteriaToRule(this.rule.id, data)
        this.$emit('created', responseData)
        setTimeout(() => {
          this.showToast(this.$t('entities.entity_aud_provider_forwarding_rules.criteria_created_successfully'), this.$store.state.successToastOptions)
          this.showModal = false
        }, 250)
      } catch (error) {
        console.log(error)
        this.showModal = false
        setTimeout(() => {
          this.showToast(this.$t('references.errors.server'), this.$store.state.errorToastOptions)
          this.$emit('canceled')
        }, 250)
      }

    },
    onCancel() {
      this.showModal = false
      setTimeout(() => {
        this.$emit('canceled')
      }, 250)
    }
  },
  computed: {
    submitEnabled: function() {
      return this.form.lead_field && this.form.comparator && (this.form.lead_field.valueDisabled === true || (this.form.lead_field.valueDisabled && this.form.value))
    },
    filteredComparators: function() {
      if(this.form.lead_field) {
        return this.form.lead_field.allowedComparators
      }
      return []
    }
  }
};
</script>

<style scoped lang="scss">

</style>
